import {
  Bot,
  Calendar,
  Database,
  Route,
  Shapes,
  type LucideIcon,
} from "lucide-react";

import { TargetEntityType } from "@/shared/domain/customFields";

interface EntityTypeTab {
  entityType: TargetEntityType;
  label: string;
  Icon: LucideIcon;
}

// Ordered Devices → Sessions → Events → Collections → Datasets. Each reuses the
// sidebar navigation icon for that entity (see navigationLinks.ts) so the cue
// matches the rest of the app.
export const ENTITY_TYPE_TABS: EntityTypeTab[] = [
  { entityType: TargetEntityType.Device, label: "Devices", Icon: Bot },
  { entityType: TargetEntityType.Session, label: "Sessions", Icon: Route },
  { entityType: TargetEntityType.Event, label: "Events", Icon: Calendar },
  {
    entityType: TargetEntityType.Collection,
    label: "Collections",
    Icon: Shapes,
  },
  { entityType: TargetEntityType.Dataset, label: "Datasets", Icon: Database },
];
